export default __webpack_public_path__ + "static/media/edge-creekside-hotels.f9beecb2.pdf";